import React, { useState, useCallback } from 'react';
import { Container } from '../../components/layout/Container';
import { PageHeader } from '../../components/layout/PageHeader';
import { QuoteForm } from '../../components/features/Quote/QuoteForm';
import { SuccessMessage } from '../../components/features/Quote/SuccessMessage';
import { sendQuoteRequest } from '../../services/api';

const INITIAL_STATE = {
  cargoType: '',
  shipmentType: '',
  from: '',
  to: '',
  weightKg: '',
  volumeM3: '',
  company: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  message: '',
};

const Quote = () => {
  const [form, setForm] = useState(INITIAL_STATE);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await sendQuoteRequest(form);
      setSent(true);
      setForm(INITIAL_STATE);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      console.error('Form submission error:', err);
      alert(err.message || 'Teklif gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.');
    } finally {
      setSending(false);
    }
  }, [form]);

  const handleNewQuote = useCallback(() => {
    setSent(false);
    setForm(INITIAL_STATE);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <PageHeader
        title="Teklif Talebi"
        description="Lojistik ihtiyaçlarınız için hızlı ve kolay teklif alın"
      />

      <Container className="py-6 sm:py-10 md:py-12">
        {sent ? (
          <div className="max-w-2xl mx-auto bg-white rounded-xl sm:rounded-2xl shadow-xl overflow-hidden">
            <SuccessMessage onClose={handleNewQuote} />
          </div>
        ) : (
          <div className="max-w-4xl mx-auto bg-white rounded-xl sm:rounded-2xl shadow-xl overflow-hidden">
            <QuoteForm
              form={form}
              onChange={handleChange}
              onSubmit={handleSubmit}
              onCancel={handleNewQuote}
              isSubmitting={sending}
            />
          </div>
        )}
      </Container>
    </div>
  );
};

export default Quote;
